export { default } from './Dropzone.js';
